import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import type { CollectionTypeDef, FormSubmission, SubmissionStats, VisitStats } from '../../lib/types';

interface UseDashboardDataResult {
  submissions: FormSubmission[];
  stats: SubmissionStats | null;
  visits: VisitStats | null;
  siteUrl: string | null;
  collectionTypes: CollectionTypeDef[];
}

export function useDashboardData(): UseDashboardDataResult {
  const [submissions, setSubmissions] = useState<FormSubmission[]>([]);
  const [stats, setStats] = useState<SubmissionStats | null>(null);
  const [visits, setVisits] = useState<VisitStats | null>(null);
  const [siteUrl, setSiteUrl] = useState<string | null>(null);
  const [collectionTypes, setCollectionTypes] = useState<CollectionTypeDef[]>([]);

  useEffect(() => {
    api.submissions.list().then(setSubmissions).catch(console.error);
    api.submissions.stats().then(setStats).catch(console.error);
    api.analytics.stats().then(setVisits).catch(console.error);
    api.collectionTypes.list().then(setCollectionTypes).catch(() => setCollectionTypes([]));
    api.settings.getSite().then((site) => {
      if (site?.domain) setSiteUrl(`https://${site.domain}`);
    }).catch(console.error);
  }, []);

  return { submissions, stats, visits, siteUrl, collectionTypes };
}
